const config = {
  CMS_API_HOST:         process.env.VUE_APP_CMS_API_HOST,
  ADMIN_API_HOST:       process.env.VUE_APP_ADMIN_API_HOST,
  ADMIN_ALLOW_HOST:     process.env.VUE_APP_ADMIN_ALLOW_HOST,
  AUTH_CLIENT_ID:       process.env.VUE_APP_AUTH_CLIENT_ID,
	AUTH_CLIENT_SECRET:   process.env.VUE_APP_AUTH_CLIENT_SECRET,
};

module.exports = config;